(function () {
  const $ = window.jQuery || window.$;
  if (!$) return;

  $(document).ready(function () {
    setTimeout(function () {
      $(".alpagas-prix ul li span").text('');

      $('.mv_out_of_stock_badge').each(function () {
        $(this).find('img').remove();
        $(this).append('<p class="epuise">Épuisé</p>');
      });
    }, 2000);

    function checkChildrenAndSetBackground() {
      if ($(window).width() >= 750) {
        $('.slideshow__text.banner__box').each(function () {
          if ($(this).children().length > 0) {
            $(this).css('background-color', 'rgba(0, 0, 0, 0.3)');
          }
        });
      }
    }

    checkChildrenAndSetBackground();

    $(window).on('resize', function () {
      checkChildrenAndSetBackground();
    });
  });
})();
